import React from 'react';
import './index.css';
import {Menu, Message, Table} from 'tinper-bee';
import Basic from '../Console/basic';
import PkgList from '../Console/pkg';
import Private from '../Console/private';
import * as util from '../../utils';

class OidCheck extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            list: [],
        };
    }


    componentDidMount() {
        this.getList()
    }

    menuClick(e) {
        this.setState({
            selectedKeys: [e.key]
        })
    }
    async getList(){
        const user_id = this.state.user_id;
        let post = {
            user_id: user_id,
            com_id: this.state.id
        };
        const res = await util.get('/npm/oid/list');
        console.log(res)
        this.setState({list: res.body})
    }
    render() {
        const { list } = this.state;
        const column = [
            {
                title: "当前打开窗口", dataIndex: "current_domainKey_name", key: "current_domainKey_name",width: '5%',
            },
            {
                title: "租户ID", dataIndex: "tenantid", key: "tenantid",width: '5%'
            },
            {
                title: "用户ID", dataIndex: "userid", key: "userid",width: '10%'
            },
            {
                title: "服务编码", dataIndex: "current_domainKey", key: "current_domainKey",width: '5%',
            },
            {
                title: "全部打开窗口", dataIndex: "_all_domainKey", key: "_all_domainKey",width: '10%',
            },
            {
                title: ">16位的数字", dataIndex: "oid", key: "oid",width: '10%'
            },
            {
                title: "JSON片段", dataIndex: "json", key: "json",width: '40%'
            },
            {
                title: "记录时间", dataIndex: "time", key: "time",width: '10%'
            },
            {
                title: "类型", dataIndex: "type", key: "type",width: '5%'
            },
        ];
        return (
            <div className=''>
                <Table
                    columns={column}
                    data={list}
                />
            </div>
        )
    }
}
export default OidCheck;
